import * as React from 'react';
import { t } from 'i18next';

import { BaseComponent } from './BaseComponent';
import { LayoutType } from '../constants/LayoutConstants';
import { SidebarModule } from '../constants/Enums';
import { ViewSettingsStore } from '../stores/ViewSettingsStore';
import { ProjectManagerStore } from '../stores/ProjectManagerStore';
import { AppConfigurationStore } from '../stores/AppConfigurationStore';
import { ViewSettingsActions } from '../actions/ViewSettingsActions';
import { Toolbar } from './Toolbar';
import { CustomLogo } from './CustomLogo';
import { PconLoginBar } from './popupmenu/PconLoginBar';
import { PRODUCT_NAME } from '../App';

interface TopBarState {
    extraButtons: boolean;
    loadedProjectName: string;
}

interface TopBarProps extends React.Props<TopBar> {
    layoutType: LayoutType;
    sidebar: SidebarModule;
    sidebarOrientation: string;
    elementsInView: boolean;
    userLanguage: string;
}

export class TopBar extends BaseComponent<TopBarProps, TopBarState> {
    public componentWillMount(): void {
        this.addStoreListener(ViewSettingsStore, this.onChange);
        this.addStoreListener(ProjectManagerStore, this.onChange);
        this.onChange();
    }

    public render(): JSX.Element | null  {
        if (this.state) {
            let cssClass: string = 'topbar-container';
            if (this.props.sidebarOrientation !== 'right') {
                cssClass += ' on-right-side';
            }
            return (
                <div className={cssClass}>
                    {this.getLabel()}
                    {AppConfigurationStore.getState().inApp ?
                        <Toolbar key="toolbar-fixed" elementsInView={this.props.elementsInView} layoutType={this.props.layoutType}/> :
                        <PconLoginBar
                            layoutType={this.props.layoutType}
                            key="pcon-login-bar"
                            userLanguage={this.props.userLanguage}
                        />
                    }
                    {!AppConfigurationStore.getState().inApp && <CustomLogo />}
                </div>
            );
        }
        return null;
    }

    protected onChange = (): void => {
        this.setState({
            extraButtons: ViewSettingsStore.getState().extraButtons,
            loadedProjectName: ProjectManagerStore.getCurrentProjectName('')
        });
    };

    protected onLabelClick = (): void => {
        /* disabled for now
        if (ProjectManagerStore.getCurrentProject() != null) {
            DialogActions.showProjectNameDialog(this.state.loadedProjectName).then(
                (newName: string) => {ProjectManagerActions.setCurrentProjectName(newName); }
            );
        }
        */
    };

    protected getLabel = (): JSX.Element => {
        let className: string = 'toolbar-label';
        if (
            (this.props.sidebar == null)
        ) {
            className += ' next-to-hamburger';
        }

        if (AppConfigurationStore.getState().projectManagerAvailable) {
            return (
                <div key="toolbar-label" className={className}>
                    <span className="toolbar-label-projects" onClick={ViewSettingsActions.gotoProjectManager}>{t('Projects')}</span>
                    <span>{this.state.loadedProjectName ? this.state.loadedProjectName : t('Unnamed')}</span>
                </div>
            );
        }
        return (
            <div key="toolbar-label" className={className + ' toolbar-label-product'}>
                <span>{PRODUCT_NAME}</span>
            </div>
        );
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/TopBar.tsx